import * as React from "react"

export const Head: React.FC<{ title: string }> = ({ title }) => {
  // react-helmet-asyncなどを使ってHeadを実装できますが、
  // とりあえずエラーを解消するために空のコンポーネントを返します。
  React.useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
};
